import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import AppWrappers from './AppWrappers';
import './bootstrap';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AppWrappers>
            <App />
        </AppWrappers>
    </React.StrictMode>,
);
